// src/lib/week.ts
import type { Habit } from '@/types';

/** Sunday = 0, Monday = 1. */
export type WeekStart = 0 | 1;

/** The five working days, starting from weekStart (e.g. Mon→[1,2,3,4,5]). */
function getWeekdays(weekStart: WeekStart): number[] {
  return Array.from({ length: 5 }, (_, i) => (weekStart + i) % 7);
}

/** The two days after the five weekdays (Mon→[6,0]; Sun→[5,6]). */
export function getWeekendDays(weekStart: WeekStart): number[] {
  return [(weekStart + 5) % 7, (weekStart + 6) % 7];
}

/** Is `habit` scheduled on day-of-week `dow` (0=Sun…6=Sat) given `weekStart`? */
export function isHabitDueOnDay(habit: Habit, dow: number, weekStart: WeekStart): boolean {
  switch (habit.frequency) {
    case 'daily':
      return true;
    case 'weekdays':
      return getWeekdays(weekStart).includes(dow);
    case 'weekends':
      return getWeekendDays(weekStart).includes(dow);
    case 'custom':
      return (habit.customDays ?? []).includes(dow);
  }
}
